export default __webpack_public_path__ + "static/media/depM.dbc53972.png";